import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { PurchaseDteRealtimeMessage } from '../../../types/websocket/PurchaseDteRealtimeMessage'

interface PurchaseDteRealtimeState {

  visible: boolean

  current: PurchaseDteRealtimeMessage | null
}

const initialState: PurchaseDteRealtimeState = {

  visible: false,

  current: null,
}

export const purchaseDteRealtimeSlice = createSlice({

  name: 'purchaseDteRealtime',

  initialState,

  reducers: {

    setRealtimeState: (
      state,
      action: PayloadAction<PurchaseDteRealtimeMessage>
    ) => {

      state.visible = true

      state.current = action.payload
    },

    clearRealtimeState: (state) => {

      state.visible = false

      state.current = null
    },
  },
})

export const {
  setRealtimeState,
  clearRealtimeState,
} = purchaseDteRealtimeSlice.actions

export default purchaseDteRealtimeSlice.reducer